import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { translations } from "./translations";

const LangContext = createContext(null);
const STORAGE_KEY = "flp.lang";

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem(STORAGE_KEY) || "id");

  useEffect(() => {
    document.documentElement.lang = lang;
    localStorage.setItem(STORAGE_KEY, lang);
  }, [lang]);

  const setLang = useCallback((next) => {
    if (next === "id" || next === "en") setLangState(next);
  }, []);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let cur = translations[lang];
      for (const p of parts) {
        if (cur && typeof cur === "object" && p in cur) cur = cur[p];
        else return path;
      }
      return cur ?? path;
    },
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be inside LangProvider");
  return ctx;
}
